import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
} from '@mui/material';
import { QrCode2 } from '@mui/icons-material';
import { QRCodeCanvas } from 'qrcode.react';
import { t } from '../i18n';
import { pushEvent } from '../utils/analytics';

// Opens a dialog showing a QR code that encodes the deep link for this code.
const QrButton = ({ url, label }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    pushEvent('qr_click', { qr_url: url });
    setOpen(true);
  };

  return (
    <>
      <Button size="small" startIcon={<QrCode2 />} onClick={handleOpen} color="primary">
        {t('QR', 'QR')}
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{t('Scan to open', 'スキャンして開く')}</DialogTitle>
        <DialogContent sx={{ textAlign: 'center', pb: 3 }}>
          <Box
            sx={{
              display: 'inline-block',
              p: 2,
              bgcolor: '#fff',
              borderRadius: 1,
            }}
          >
            <QRCodeCanvas value={url} size={200} />
          </Box>
          {label && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              {label}
            </Typography>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default QrButton;
